import { jwtDecode } from 'jwt-decode';
import type { User } from '@/core/user/user.model';

interface CognitoIdTokenClaims {
  email?: string;
  name?: string;
}

function decodeClaims(idToken: string): CognitoIdTokenClaims | undefined {
  try {
    return jwtDecode<CognitoIdTokenClaims>(idToken);
  } catch {
    return undefined;
  }
}

export function userFromIdToken(idToken: string): User | undefined {
  const claims = decodeClaims(idToken);
  if (!claims) return undefined;

  const email = claims.email;
  if (email === undefined || email === '') return undefined;

  return {
    email,
    name: claims.name ?? email,
    // TODO: replace with role derived from Cognito claims/groups once backend supports it
    role: 'COURTIER',
  };
}
